import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const NoCalendarPlaceholder = ({
    label,
    onChangeShowAllPhotographers,
    showAllPhotographersButtonLabel
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 'auto',
                border: '1px solid #E0E0E0',
                marginTop: '44px',
                marginLeft: '16px',
                borderRadius: '5px',
                width: '64%',
                height: '77vh',
                flexDirection: 'column',
                gap: '20px'
            }}
            aria-label="no-calendar-placeholder"
        >
            <Typography>{label}</Typography>
            <Button variant="contained" onClick={onChangeShowAllPhotographers}>
                {showAllPhotographersButtonLabel}
            </Button>
        </Box>
    );
};

export default NoCalendarPlaceholder;
